import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import {
  Box,
  Typography,
  Card,
  Avatar,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AOS from "aos";
import "aos/dist/aos.css";
import { market } from "../../CommonPage/MarketFlow/TradeData";
import { useLanguage } from "../../context/LanguageContext";

const GlobalIndicc = ({  }) => {

  const theme = useTheme();
  const { language, translations } = useLanguage();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const [data, setData] = useState(market);

  console.log("fsgfsagasf",data);
  
  useEffect(() => {
    const ws = new WebSocket(
      "wss://websocket-website.cfifinancial.com:2053/prices?ApiKey=9djd82jd0_s62hs71kd06xj27&Symbols=AUDNZD,AUDCAD,AUDCHF,AUDJPY,CHFJPY,EURGBP,EURAUD,EURCHF,EURJPY,EURNZD,EURCAD,GBPCHF,AAL.OQ,AAPL.OQ,AMZN.OQ,ANGH.OQ,BABA.N,GOOGL.OQ,IBM.N,INTC.OQ,KO.N,LCID.OQ,META.OQ,MSFT.OQ,NFLX.OQ,NIO.N,NVDA.OQ,PYPL.OQ,SNAP.N,TSLA.OQ,XAUAUD_,XAUEUR_,XAUGBP_,XAUUSD_,XAGEUR_,XAGUSD_,XAUAUD,XAUEUR,XAUGBP,XAUUSD,XAGEUR,XAGUSD,NatGas_SPOT,BRENT,WTI,CAC40_SPOT,CH20_SPOT,EUR50_SPOT,GER30_SPOT,IBEX35_SPOT,IT40_SPOT,NL25_SPOT,NO25_SPOT,UK100_SPOT,AUS200_SPOT,CA60_SPOT,HKD50_SPOT,AAA,AAAU,AADR,AAPB,AAPD,AAPU,ABEQ,ACES,ACIO,ACTV,ACVF,ACWV,ADAUSD,BCHUSD,BTCUSD,DOGUSD,ETHUSD,SOLUSD,TRXUSD,XRPUSD,BAXM4,FEIM4,FLGU4,LCCN4,CCU4,KC0724,HGCN4,CTZ4,NatGas_N4,NatGas_Q4,USOIL_N4,UKOIL_Q4,PL0724,ZS0724"
    );

    ws.onopen = () => {
      console.log("WebSocket Connected");
    };

    ws.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        setData((prevData) => {
          return {
            ...prevData,
            ["Indices"]: prevData?.["Indices"].map((item) =>
              item.name === data.Symbol
                ? {
                  ...item,
                  price: data?.Bid?.toFixed(4),
                  Change: data?.DayChange?.toFixed(4),
                }
                : item
            ),
          };
        });
      } catch (error) {
        console.error("Error parsing WebSocket data:", error);
      }
    };

    ws.onclose = () => {
      console.log("WebSocket Disconnected. Attempting to reconnect...");
    };

    ws.onerror = (error) => {
      console.error("WebSocket Error:", error);
    };

    return () => {
      ws.close();
    };
  }, []);

  const settings = {
    infinite: true,
    speed: 5000, // duration to move one slide
    autoplay: true,
    autoplaySpeed: 0, // continuous
    cssEase: "linear", // constant motion — no easing in/out
    pauseOnHover: false,
    arrows: false,
    swipe: false, // optional: avoids touch interrupt
    draggable: false, // optional: prevents mobile stutter
    slidesToShow: 4,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1.5 }, // show part of next card
      },
    ],
  };



  return (
    <Box
      sx={{
       backgroundImage:
          "linear-gradient(to right, #f2f9fc 0%, #f3f9fc 0%, #f3f9fc 82%) ",
        py: { xs: 4, md: 5 },
        marginTop:{xs:"0px",md:"-6rem"}

        
      }}
    >
      <Box
      // data-aos="zoom-in"
      // data-aos={!isSmallScreen ? "zoom-in" : undefined}
      >
        <Typography
          align="center"
          sx={{
            fontWeight: 700,
            mb: 3,
            color: "#000",
            fontSize: {
              xs: "25px !important",
              sm: "28px !important",
              md: "35px !important",
            },
            fontFamily: "SF Pro Display",
          }}
        >
          {translations[language]?.easyAccessTo}{" "}
          <span style={{ color: "#2494C9" }}>1,400+</span>{" "}
          {translations[language]?.global}
          <Box
            component="span"
            sx={{
              display: { xs: "block", sm: "inline" },
              marginTop: { xs: "15px", md: "0px" },
            }}
          >
            {" "}
            {translations[language]?.assets}
          </Box>
        </Typography>
      </Box>

      <Box sx={{ mx: "auto", mt: 4,  }}>
        <Box sx={{ overflow: "hidden", minWidth: 0 }}>
          <Slider {...settings} style={{ marginLeft: 0, marginRight: 0 }}>
            {data["Indices"]?.map((asset, index) => (
              <Box key={index} sx={{ px: 1, padding: "10px" }}>
                {" "}
                {/* Adjust gap here */}
                <Card
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    p: 3,
                    borderRadius: "18px",
                    height: 100,
                    gap: "10px",
                    textAlign: "center",
                    boxSizing: "border-box",
                    boxShadow: "none",
                    willChange: "transform",
                    // width:{md:"250px" }
                  }}
                  // elevation={2}
                >
                  <Avatar
                    src={asset?.icon}
                    alt={asset.name}
                    variant="square"
                    sx={{
                      width: 50,
                      height: 50,
                      bgcolor: "transparent",
                      borderRadius: "8px", // optional, for rounded corners
                      img: {  
                        objectFit: "contain", // ensures full image fits inside
                      },
                    }}
                  />

                  <Box pl={2}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "20px",
                        paddingLeft: { md: "0px", xs: "0px", sm: "0px" },
                        textAlign: "start",
                        direction: "ltr", // Keep asset names in LTR direction
                      }}
                    >
                      {asset?.name}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: asset?.price < 0 ? "#FF7677" : "#00C381",
                        fontSize: "18px",
                        textAlign: "start",
                        direction: "ltr", // Keep prices in LTR direction
                      }}
                    >
                      {asset?.price}
                    </Typography>
                  </Box>
                </Card>
              </Box>
            ))}
          </Slider>
        </Box>
      </Box>
    </Box>
  );
};

export default GlobalIndicc;
